<div class="off-canvas-content">
    <div class="offCanvas__container">
        <div class="offCanvas__contentWrapper">
            <div class="offCanvas__header">
                <div class="offCanvas__title">
                   Scan Document
                </div>
                <img (click)="onCloseIconClick()" class="offCanvas__crossIcon"
                    src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
            </div>
            <app-dwt *ngIf="!bStartUp" [events]="eventsSubject.asObservable()" (closePopupEvent)="onCloseIconClick()"></app-dwt>
        </div>
    </div>
</div>